import { useContext, useCallback } from 'react'
import { Tabs, Form } from 'antd'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import Loader from '../../components/Loader'

import { AppContext } from '../../context/AppContext'
import { getCommunities } from '../../network/API'
import { CreateCustomer } from '../../network/Customers'
import {
    PersonalInformation,
    Contacts,
    Fapiao,
    WeChatGroups,
    Address,
    Pets,
    CustomerTags,
    buildWechatGroups,
    cleanBeforeSending,
} from '../../constants/forms/Customers'
import { promptLinkGiftCardsToCustomer } from '../../utils/customerGiftCardLink'

const { TabPane } = Tabs

const CustomersDetail = () => {
    const [form] = Form.useForm()
    const { t } = useTranslation()
    const { token } = useContext(AppContext)

    const communities = useQuery(
        ['getCommunities', { token: token.token, range: [0, 99] }],
        getCommunities
    )

    const wechatGroups = buildWechatGroups(communities.data?.list || [])

    const handleBeforeOnSuccess = useCallback(
        async (customer) => {
            await promptLinkGiftCardsToCustomer({
                customer,
                token: token.token,
                t,
            })
        },
        [token.token, t]
    )

    return (
        <PageWrap goBack title="CUSTOMERS_CREATE_CUSTOMER">
            <Tabs
                defaultActiveKey="1"
                className="customerDetailTab"
                style={{ backgroundColor: '#fff', padding: '0px' }}
            >
                <TabPane tab={t('CUSTOMERS_INFORMATION')} key="1">
                    {communities.isLoading ? (
                        <Loader />
                    ) : (
                        <FormWrap
                            form={form}
                            title="create_recipe"
                            request={CreateCustomer}
                            onSuccess={'/customers'}
                            onCancel={'/customers'}
                            data={{ wechatGroups }}
                            cleanBeforeSending={cleanBeforeSending}
                            invalidate={['getCustomers', 'getGiftCards']}
                            beforeOnSuccess={handleBeforeOnSuccess}
                        >
                            <div className="SectionHorizontalWrap">
                                <div
                                    className="SectionVerticalWrap"
                                    style={{ flex: 2 }}
                                >
                                    <FormBlock
                                        form={form}
                                        formTemplate={PersonalInformation}
                                    />
                                    <FormBlock
                                        form={form}
                                        formTemplate={Address}
                                    />
                                    <FormBlock
                                        form={form}
                                        formTemplate={Contacts}
                                    />
                                    <FormBlock
                                        form={form}
                                        formTemplate={Fapiao}
                                    />
                                </div>

                                <div
                                    className="SectionVerticalWrap"
                                    style={{ flex: 1 }}
                                >
                                    <FormBlock
                                        form={form}
                                        formTemplate={WeChatGroups}
                                    />
                                    <FormBlock form={form} formTemplate={Pets} />
                                    <FormBlock
                                        form={form}
                                        formTemplate={CustomerTags}
                                    />
                                </div>
                            </div>
                        </FormWrap>
                    )}
                </TabPane>
                <TabPane tab={t('MENU_ORDERS')} key="2" disabled />
                <TabPane tab={t('CUSTOMERS_VOUCHERS')} key="3" disabled />
                <TabPane tab={t('MENU_CLAIMS')} key="4" disabled />
                <TabPane tab={t('MENU_ANALYTICS')} key="5" disabled />
            </Tabs>
        </PageWrap>
    )
}

export default CustomersDetail
